"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pinoGroupedLogHandlers = void 0;
var _types = require("../../types");
var _pinoApplicationInsightsLogHandler = require("./pinoApplicationInsightsLogHandler");
var _pinoConsoleLogHandler = require("./pinoConsoleLogHandler");
/** Collection of log handlers for each transport type */
const pinoGroupedLogHandlers = exports.pinoGroupedLogHandlers = {
  [_types.LoggerTransportType.APPLICATION_INSIGHTS]: _pinoApplicationInsightsLogHandler.pinoApplicationInsightsLogHandler,
  [_types.LoggerTransportType.CONSOLE]: _pinoConsoleLogHandler.pinoConsoleLogHandler
};
